





































































































import {Site} from "@/shared/Site";
import {Enseigne} from "@/shared/Enseigne";
import {Groupe} from "@/shared/Groupe";
import {Component, Prop, Watch, Ref} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import SelectedSites from "@/ui-component/selectedSites.vue";
import ListeGroupes from "@/components/listeGroupes.vue";
import {debounce} from "lodash";

@Component({
  components: {SelectedSites, ListeGroupes},
})
export default class ListeSites extends mixins(MobileMixin) {
  public searchTxt: string = "";
  public searchTxtGr: string = "";
  public selectedGroupe: string = "TOUS";
  public showMenu = false;
  public restaurantIds_to_enseigne: any = {};
  public selectedIds: Set<number> = new Set<number>();
  @Prop({default: false}) public isFavoris!: boolean;
  @Prop({default: null}) public lSites!: Site[];
  @Prop({default: "vertical"}) public orientation!: string;
  @Prop({default: true}) public showSelected!: boolean;
  @Prop({default: true}) public showSelectAll!: boolean;
  @Prop({default: false}) public showVendeurs!: boolean;
  @Ref() public listeRef!: HTMLDivElement;
  public parentWidth: number = 0;
  public resizeObserver!: ResizeObserver;

  public created() {
    const enseignes = this.enseignes;
    enseignes.forEach((enseigne: Enseigne) => {
      this.restaurantIds_to_enseigne[enseigne.restaurantId] = enseigne.libelle;
    });
    if (this.lSites) {
      this.lSites.forEach((site: Site) => {
        this.selectedIds.add(site.restaurantId);
      });
    }
  }

  public mounted() {
    this.$nextTick(() => {
      const parentNode = this.listeRef && this.listeRef.parentNode;
      if (!parentNode || !(parentNode instanceof HTMLElement)) {
        console.warn("Impossible de trouver le parent du composant !");
        return;
      }

      const parentElement = parentNode as HTMLElement;

      this.resizeObserver = new ResizeObserver(() => {
        this.updateParentWidth(parentElement);
      });

      this.resizeObserver.observe(parentElement);
      this.updateParentWidth(parentElement);
    });
  }

  /**
   * Fonction pour mettre à jour la largeur du parent.
   */
  public updateParentWidth(parentElement: HTMLElement): void {
    if (!this.listeRef) {
      console.warn("listeRef n'est pas défini !");
      return;
    }
    this.parentWidth = this.listeRef.offsetWidth || 0;
  }

  /*
   * methode de filtre depuis le champs de texte des sites repondant au critere de texte
   */
  public searchSiteFilter() {
    // console.log("get mes sites ", this.ouPan);
    let mesSites = this.sites;
    if (!["TOUS", "AUCUN"].includes(this.selectedGroupe)) {
      mesSites = this.sites.filter((site: Site) => {
        return site.groupe.indexOf(this.selectedGroupe) !== -1;
      });
      // console.log(mesSites)
    } else {
      mesSites = this.sites;
    }
    // console.log(mesSites);
    if (this.searchTxt.trim() !== "") {
      const matchedRestaurantIds = Object.keys(
          this.restaurantIds_to_enseigne
      ).filter((key) =>
          this.restaurantIds_to_enseigne[key]
              .toUpperCase()
              .includes(this.searchTxt.toUpperCase())
      );
      mesSites = mesSites.filter((site: Site) => {
        return (
            site.libelle.includes(this.searchTxt.toUpperCase()) ||
            site.restaurantId.toString().includes(this.searchTxt) ||
            matchedRestaurantIds.includes(site.restaurantId.toString()) ||
            (site.codeAlpha &&
                site.codeAlpha.toUpperCase().includes(this.searchTxt.toUpperCase())) ||
            // Donnée pour total:
            (site.extras &&
                site.extras.code_implant &&
                site.extras.code_implant.includes(this.searchTxt.toUpperCase()))
        );
      });
    }
    // mesSites.sort((a, b) => a.libelle.localeCompare(b.libelle));
    return mesSites;
  }

  public selectGroupe(gr: any) {
    this.selectedGroupe = gr;
    let sitesToAdd: Site[] = [];

    const groupe = this.groupements.find((g: Groupe) => {
      return g.raisonSociale === gr;
    });

    if (!["TOUS", "AUCUN"].includes(this.selectedGroupe) && groupe) {
      for (const id of groupe.restaurantIds) {
        const site = this.sites.find((s: Site) => {
          return s.restaurantId === id;
        });

        if (site) {
          sitesToAdd.push(site);
        } else {
          console.error("site non trouvé", id);
        }
      }
    } else {
      if (gr === "TOUS") {
        sitesToAdd = this.sites.filter(
            (site: Site) => this.mesSites.indexOf(site) === -1
        );
      } else {
        sitesToAdd = this.sites.filter(
            (site: Site) => this.mesSites.indexOf(site) !== -1
        );
      }
    }

    for (const site of sitesToAdd) {
      this.addSite(site);
    }
    this.showMenu = false;
  }

  @Watch("listeSites", {immediate: true})
  public onPropertyChanged(value: any, oldValue: any) {
    if (oldValue === undefined) {
      this.mesSites = this.listeSites.filter(
          (site: Site) => site.libelle === "hack"
      );
    }
  }

  public selectAll() {
    let mesSites = this.sites;
    if (!["TOUS", "AUCUN"].includes(this.selectedGroupe)) {
      mesSites = this.sites.filter((site: Site) => {
        return site.groupe.indexOf(this.selectedGroupe) !== -1;
      });
    } else {
      mesSites = this.sites;
    }
    const sitesToAdd = mesSites.filter(
        (site: Site) => this.mesSites.indexOf(site) === -1
    );
    for (const site of sitesToAdd) {
      if (!this.selectedIds.has(site.restaurantId)) {
        this.$emit("addSite", site);
        this.updateSelectedIds(site);
      }
    }
  }

  /**
   * methode de deselection de tous les sites
   */
  public selectNone(): void {
    // Récupérer les sites actuellement affichés selon le filtre
    let mesSites = this.sites;
    if (!["TOUS", "AUCUN"].includes(this.selectedGroupe)) {
      mesSites = this.sites.filter((site: Site) => {
        return site.groupe.indexOf(this.selectedGroupe) !== -1;
      });
    }

    for (const site of mesSites) {
      if (this.selectedIds.has(site.restaurantId)) {
        this.removeSite(site);
      }
    }

    // Réinitialiser la sélection
    this.selectedIds = new Set();
  }

  /*
   * methode de verrification qu'un site est selectionné
   * @param {Site} site- le site à verifier
   */
  public updateSelectedIds(site: Site): void {
    const updatedSelectedIds = new Set(this.selectedIds);
    if (updatedSelectedIds.has(site.restaurantId)) {
      updatedSelectedIds.delete(site.restaurantId);
    } else {
      if (this.showSelectAll) {
        updatedSelectedIds.add(site.restaurantId);
      } else {
        updatedSelectedIds.clear();
        updatedSelectedIds.add(site.restaurantId);
      }
    }
    this.selectedIds = updatedSelectedIds;
  }

  /*
   * methode de selection d'un site
   * @param {Site} site - le site à selectionner
   */
  public addSite(site: Site) {
    // console.log("add", site);
    this.$emit("addSite", site);
    this.updateSelectedIds(site);
  }

  /*
   * methode de supression d'un site selectionné
   * @param {Site} site - le site à supprimer
   */
  public removeSite(site: Site) {
    if (!site) {
      return;
    }
    this.$emit("removeSite", site);
    // const updatedSelectedIds = new Set(this.selectedIds);
    // updatedSelectedIds.delete(site.restaurantId);
    // this.selectedIds = updatedSelectedIds;

    this.selectedIds.delete(site.restaurantId);
  }

  /*
   * methode de mise a jour de la liste des caisses depuis le composant vers la page qui l'affiche
   */
  public updateCaisses(listeCaisses: any) {
    this.$emit("updateCaisses", listeCaisses);
  }

  public updateVendeur(vendeur: string) {
    this.$emit("updateVendeur", vendeur);
  }

  /*
   * ensemble des sites existants
   */
  get sites(): Site[] {
    const sites = this.$store.getters["login/sites"];
    sites.sort((u1: Site, u2: Site) => {
      return u1.restaurantId < u2.restaurantId;
    });
    return sites;
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }

  /*
   * ensemble des groupements existants
   */
  get groupements(): Groupe[] {
    const gpm = this.$store.getters["login/groupements"];
    return gpm;
  }

  get listeSites(): Site[] {
    let rap;
    if (this.isFavoris) {
      rap = this.$store.getters["rapport/selectedFavoris"];
    } else {
      rap = this.$store.getters["rapport/rapport"];
    }
    return rap.lSites;
  }

  get mesSites(): Site[] {
    let sites;
    if (this.lSites !== null) {
      sites = this.lSites.sort((u1: Site, u2: Site) => {
        if (u1.restaurantId > u2.restaurantId) {
          return 1;
        } else if (u1.restaurantId < u2.restaurantId) {
          return 1;
        } else {
          return 0;
        }
      });
    } else {
      sites = this.listeSites.sort((u1: Site, u2: Site) => {
        if (u1.restaurantId > u2.restaurantId) {
          return 1;
        } else if (u1.restaurantId < u2.restaurantId) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return sites;
  }

  set mesSites(sites: Site[]) {
    // Commentaire pour éviter l'erreur de compilation
  }

  public get dynamicStyle(): object {
    // console.log("largeur du parent: ", this.parentWidth);
    if (this.parentWidth < 285) {
      return {
        marginBottom: "8px",
        fontSize: "14px",
      };
    } else {
      return {};
    }
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
